export default __webpack_public_path__ + "static/media/488.e9f4370e.jpg";